import { Symbols } from '../symbols';
import { CooperativeCompanyService } from './CooperativeCompanyService';
import { makeCooperativeCompaniesUrl } from './urls';
export function configService(config) {
    const { container, boBaseUrl, } = config;
    const urls = makeCooperativeCompaniesUrl(boBaseUrl);
    container.bind(Symbols.CooperativeCompanyServiceUrls).toConstantValue(urls);
    container.bind(Symbols.CooperativeCompanyService).to(CooperativeCompanyService);
}
